var $ = require("./lib/qsa");
var track = require("./lib/tracking");
// var flags = require("./flags");
var here = new URL(window.location.href);
var renderPlatform = here.searchParams.get("renderPlatform");
var flags = {
  autoplay: true,
  isOne: renderPlatform && renderPlatform.match(/nprone/i)
};

//  buttons that effect the timelapse
var toggles = $(".local-playback");

// all autoplayed videos (including timelapse)
var autoplayers = $("video[autoplay]");

// handle accessibility toggles
var autoplayChecks = $(".a11y-controls input");

var toggleAutoplay = function (enable, trackThis) {
  if (trackThis) {
    track("autoplay-toggle", enable);
  }
  autoplayChecks.forEach(a => a.checked = enable);
  if (enable) {
    autoplayers.forEach(function (video) {
      video.setAttribute("autoplay", "");
      if (!video.paused || flags.isOne) return;
      var promised = video.play();

      // ignore DOMExceptions for playback, they can get tripped up by the lazy load
      if (promised) promised.catch(err => err);
    });
    toggles.forEach(t => toggleButton(t,'pause'));
  } else {
    autoplayers.forEach(function (video) {
      video.removeAttribute("autoplay");
      video.pause();
    });
    toggles.forEach(t => toggleButton(t,'pause'));
  }
};

var toggleButton = function(t,state) {
  t.querySelector('.controls-text').innerHTML = `${state} timelapse video`
  t.querySelectorAll('.playback-icon').forEach(b => b.classList.remove('active'))
  t.querySelector(`#${state}`).classList.add('active')
}

autoplayChecks.forEach(a => a.checked = flags.autoplay);

autoplayChecks.forEach(a => a.addEventListener("change", e =>
  toggleAutoplay(e.target.checked, true)
));

var reducedMotion = window.matchMedia("(prefers-reduced-motion)");
if ("addEventListener" in reducedMotion) {
  reducedMotion.addEventListener("change", () =>
    toggleAutoplay(!reducedMotion.matches)
  );
} else {
  reducedMotion.addListener(() => toggleAutoplay(!reducedMotion.matches));
}
if (autoplayChecks[0]) {
  toggleAutoplay(!reducedMotion.matches && autoplayChecks[0].checked);
}

toggles.forEach(toggle => toggle.addEventListener("click", function() {
  if (timelapse.paused) {
    timelapse.play();
    
    toggles.forEach(t => toggleButton(t,'pause'));
  } else {
    timelapse.pause();
    
    toggles.forEach(t => toggleButton(t,'play'));
  }
}));

track("prefers-reduced-motion", reducedMotion.matches);
